import _ from 'lodash';
import defaultState from './defaultState';
import * as types from '../../mutationTypes';

export default {
  /* eslint-disable no-param-reassign */
  // eslint-disable-next-line no-unused-vars
  [types.RESET_APPEARANCE](state) {
    // eslint-disable-next-line no-unused-vars
    state = _.deepClone(defaultState);
  },

  [types.SET_SEARCH_PANEL](state, value) {
    state.showSearchPanel = value;
  },

  [types.SET_FULLSCREEN](state, value) {
    state.isFullScreen = value;
  },

  [types.SET_PREFERENCES_VIEW](state, value) {
    state.isPreferencesView = value;
  },

  [types.SET_ISMOBILE](state, value) {
    state.isMobile = value;
  },

  [types.SET_IS_PUBLIC_VIEW_MODE](state, value) {
    state.isPublicViewMode = value;
  },

  [types.SET_IS_LOADING_IMAGES](state, value) {
    state.isLoadingImages = value;
  }
  /* eslint-enable no-param-reassign */
};
